import * as React from "react";
import { Box, Typography, useTheme, Grid, InputBase } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { API_ENDPOINT_URL } from "../../util/api";
import { getLocalItem } from "../../util/helper";
import DragDropFileCSV from "../../components/DragDrop";
import TableFileImportRealtime from "../../components/TableFileImportRealtime";
import TableImportData from "../../components/TableImportData";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import FormControl from "@mui/material/FormControl";
const timezone = "Asia/Tokyo";

const columns = [
  {
    field: "is_phish",
    headerName: "isPhish",
  },
  {
    field: "domain",
    headerName: "Domain",
    cellClassName: "name-column--cell",
  },
  {
    field: "url",
    headerName: "URL",
  },
  {
    field: "brand",
    headerName: "Brand",
  },
  {
    field: "score",
    headerName: "DomainScore",
  },
  {
    field: "is_alive",
    headerName: "SiteAlive",
  },
  {
    field: "payload_created",
    headerName: "Created",
  },
];

const FileImportRealtime = () => {
  const [loading, setLoading] = useState(false);
  const token = getLocalItem("key");
  const [fileListData, setFileListData] = useState([]);

  const [data, setData] = useState([]);
  const [showData, setShowData] = useState([]);
  const [fetchData, setFetchData] = useState([]);
  const originDataRef = useRef([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchParam, setSearchParam] = useState({
    ordering: "payload_created,domain",
  });

  const handleSearch = (searchParamsVar) => {
    const { searchText, currentPageChange, sort } = searchParamsVar;
    setCurrentPage(currentPageChange);
    setSearchParam({
      file_name: searchParam.file_name,
      created: searchParam.created,
      page: currentPageChange,
      ordering: sort.column !== "domain"
        ? `${sort.order}${sort.column},domain`
        : `${sort.order}${sort.column}`,
        search: searchText,
    });
  };

  useEffect(() => {
    axios
      .get(`${API_ENDPOINT_URL}/file/upload/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setFileList(response.data);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    if (searchParam.file_name) {
      setLoading(true);
      axios
        .get(`${API_ENDPOINT_URL}/file/realtime/`, {
          params: { ...searchParam },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          setData(response.data);
          originDataRef.current = _.cloneDeep(response.data)
        })
        .catch((error) => {})
        .finally(() => setLoading(false));
    }
  }, [searchParam, currentPage]);

  useEffect(() => {
    if(data?.results?.length > 0) {
      const intervalId = setInterval(() => {
        axios
          .get(`${API_ENDPOINT_URL}/file/polling/`, {
            params: { ...searchParam },
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => {
            let temp = _.cloneDeep(originDataRef.current)
            let dataChange = _.cloneDeep(response.data);
            const updatedData = temp.results.map((originItem) => {
              const correspondingItem = dataChange.results.find((item) => item.domain === originItem.domain);
          
              if (correspondingItem && !_.isEqual(originItem, correspondingItem)) {
                let changedColumns = [];
                for (let key in originItem) {
                  if (!_.isEqual(originItem[key], correspondingItem[key])) {
                    changedColumns.push(key);
                    originItem[key] = correspondingItem[key];
                  }
                }
                originItem.changeColumn = changedColumns;
              } else {
                originItem.changeColumn = [];
              }
          
              return originItem;
            });
            
            let dataTmp = _.cloneDeep(originDataRef.current);
            dataTmp = {...dataTmp ,results:_.cloneDeep(updatedData)}
            setData(dataTmp);

            let removeKey = _.cloneDeep(updatedData)
            removeKey.map(function(item) { 
              delete item.changeColumn; 
              return item; 
            });
            
            originDataRef.current = {...originDataRef.current, results:removeKey}
          })
          .catch((error) => {});
      }, 2000);
      return () => {
        clearInterval(intervalId); // Clear the interval when the component is unmounted or when data changes
      };
    }
  }, [data]);

  const [selectedFile, setSelectedFile] = useState("");
  const [fileList, setFileList] = useState([]);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.value);
    setCurrentPage(1);
    setSearchParam({
      page: 1,
      ordering: "payload_created,domain",
      file_name: event.target.value.file_name,
      created: event.target.value.created,
    });
  };

  return (
    <Box
      m="20px"
      sx={{
        // backgroundColor: "red",
        width: "100%",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          //   backgroundColor: "yellow",
          width: "100%",
          textAlign: "center",
        }}
      >
        <Grid container spacing={0}>
          <Grid item lg={12} sm={12} md={12}>
            <Box>
              <Typography
                variant="h1"
                fontSize={40}
                fontWeight="bold"
                color="#2699fb"
                textAlign="left"
              >
                Realtime Process File Import
              </Typography>
            </Box>
            <Box mt={4}>
              <Grid container spacing={0} alignItems="center">
                <Grid item>
                  <Typography variant="body1" fontSize={20} color="#707070">
                    Select Process File :
                  </Typography>
                </Grid>
                <Grid item>
                  <FormControl sx={{ m: 1, minWidth: 220}} size="medium">
                  <Select
                    value={selectedFile}
                    onChange={handleFileChange}
                    displayEmpty
                    variant="outlined"
                    margin="dense"
                    renderValue={(value) => (value ? `${value.file_name}` : 'Select a file')}
                    sx={{
                      border: "2px solid #2699fb",
                      borderRadius: "50px",
                      color: "#2699fb",
                    }}
                  >
                    {fileList.map((file, index) => (
                      <MenuItem key={index} value={file}>
                        <ListItemText
                          primary={file.file_name}
                          secondary={`Created: ${file.created}`}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item lg={1} sm={0} md={0}></Grid>
        </Grid>

        {data ? (
          <Box mt={5} width="100%">
            <TableFileImportRealtime
              rows={data.results}
              columns={columns}
              totalPage={data.last_page_number}
              onSearch={handleSearch}
              loading={loading}
              currentPage={currentPage}
            />
          </Box>
        ) : (
          <p>No data available</p>
        )}
      </Box>
    </Box>
    // </ThemeProvider>
  );
};

export default FileImportRealtime;
